import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { startPageFeatureData } from '../../data/featureCardData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import { PageHeadingWrapper } from '../../components/PageWrapper/styles'
import PageHeader from '../../components/PageHeader'
import Headings from '../../components/Headings'
import ImageCard from '../../components/ImageCard'
import PageNavButton from '../../components/PageNavButton'
import FeatureCard from '../../components/FeatureCard'
import PreconsentFooter from '../../components/PreconsentFooter'

const StartPage = () => {
  const navigate = useNavigate()
  return (
    <PageWrapper>
      <Helmet>
        <title>CompareBanks</title>
      </Helmet>

      <PageContentWrapper>
        <PageHeader
          headerTitle="CompareBanks"
          workflow="Pre-Consent"
          haveMenu={false}
          isFocused={true}
          titleLabel="coampare banks : Homepage"
        />
        <PageHeadingWrapper>
          <Headings
            level="h1"
            text="Easily compare and apply for new banking products."
          />
        </PageHeadingWrapper>
        <ImageCard alt={'image of a person typing'} />
        <PageNavButton
          onClickFunc={() => navigate('/step-loading')}
          content="Get started"
          ariaLabel="start button, to open CompareBanks app double click here"
          isInPageBody={true}
          //isFocused={true}
        />

        {startPageFeatureData.map((item, index) => (
          <FeatureCard {...item} key={index} />
        ))}
      </PageContentWrapper>
      <PageNavButton
        onClickFunc={() => navigate('/step-loading')}
        title="Ready to save?"
        content="Get started"
        ariaLabel="start button, to open CompareBanks app double click here"
      />
      <PreconsentFooter />
    </PageWrapper>
  )
}

export default StartPage
